import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import UserTypeSelectComponent from "../UserTypeSelectComponent/UserTypeSelectComponent";
import MultiSelectCmTwo from "../MultiSelectCmTwo/MultiSelectCmTwo";
import SelectComp from "../../NewComponent/Select/Select";
import Styles from './cmOverviewStyles.module.css'
import { Select } from 'antd';

const array1 = [
  { label: "All", value: null },
  { label: "Employee", value: 1 },
  { label: "Customer", value: 2 },
  { label: "Partner", value: 3 },
];
export const UserType = () => {
  const selectUser = useSelector((state) => state.seekerType);
  const cmOverviewReducer = useSelector((state) => state.cmOverview);
  const dispatch = useDispatch();
  const documentUserType = useSelector((state) => state.documentTab);
  const {
    getSelectedUserTypeInOverview,
    SeekerUserTypeAction,
    documentTypeAction,
    getTabIndex,
    getSlackTab,
  } = bindActionCreators(Actions, dispatch);
  const onChangeData = (data) => {
    // console.log("data", data)
    getSelectedUserTypeInOverview(data);
  };

  const changeSeeker = (value) => {
    SeekerUserTypeAction(value);
  };
  const onChangeDocument = (data) => {
    documentTypeAction(data);
  };
  // console.log('cmover', cmOverviewReducer.userTypeSelect, array1,)
  return (
    <>
      {cmOverviewReducer.selectedTab === "1" ? (
        <>
          <span style={{ marginLeft: "5px", display: "flex", width: "130px" }}>
            {/* <label>User Type:</label> */}
            {/* <MultiSelectCmTwo
              disabled={false}
              value={cmOverviewReducer.userTypeSelect}
              onChangeFunc={onChangeData}
              // isMulti={true}
              options={array1}
            /> */}
            <Select
              labelInValue
              options={array1}
              showSearch
              value={cmOverviewReducer.userTypeSelect}
              defaultValue={{ label: 'All', value: null }}
              onChange={onChangeData}
              placeholder="Select Group"
              popupClassName={Styles.selectCss} 
              dropdownStyle={{ zIndex: 0, textAlign: "left" }}
              size="middle"
              style={{width:"100%",border:'none', boxShadow:'0px 1px 2px 0px #1018280D',fontSize:'16px'     }}
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              // size={"medium"}
              // width={"100px"}
            />
          </span>
          {/* <div style={{ display: "flex", marginTop: "2px" }}>
            <span style={{ marginRight: "10px" }}>User Type:</span>
            <UserTypeSelectComponent
              values={cmOverviewReducer.userTypeSelect}
              handler={onChangeData}
            />
          </div> */}
        </>
      ) : cmOverviewReducer.selectedTab === "2" ? (
        <>
          <span style={{  display: "flex", width: "130px" }}>
            {/* <MultiSelectCmTwo
              disabled={false}
              value={selectUser.userType}
              onChangeFunc={changeSeeker}
              // isMulti={true}
              options={array1}
            /> */}
             <Select
              labelInValue
              showSearch
              options={array1}
              value={selectUser.userType}
              defaultValue={{ label: 'All', value: null }}
              onChange={changeSeeker}
              dropdownStyle={{ zIndex: 0, textAlign: "left" }}
              placeholder="Select Group"
              popupClassName={Styles.selectCss} 
              size="middle"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              style={{width:"100%",border:'none', boxShadow:'0px 1px 2px 0px #1018280D',fontSize:'16px'     }}
              // size={"medium"}
              // width={"100px"}
            />
          </span>
          {/* <div
            style={{ display: "flex", alignItems: "center", marginTop: "2px" }}
          >
            <span style={{ marginRight: "10px" }}>User Type:</span>
            <UserTypeSelectComponent
              values={selectUser.userType}
              handler={changeSeeker}
            />
          </div> */}
        </>
      ) : cmOverviewReducer.selectedTab === "4" ? (
        <>
          <span style={{ marginLeft: "5px", display: "flex", width: "130px" }}>
            {/* <MultiSelectCmTwo
              disabled={false}
              value={documentUserType.userType}
              onChangeFunc={onChangeDocument}
              // isMulti={true}
              options={array1}
            /> */}
              <Select
              labelInValue
              showSearch
              options={array1}
              dropdownStyle={{ zIndex: 0, textAlign: "left" }}
              value={documentUserType.userType}
              defaultValue={{ label: 'All', value: null }}
              onChange={onChangeDocument}
              placeholder="Select Group"
              popupClassName={Styles.selectCss} 
              size="middle"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              style={{width:"100%",border:'none', boxShadow:'0px 1px 2px 0px #1018280D',fontSize:'16px'     }}
              // size={"medium"}
              // width={"100px"}
            />
          </span>
          {/* <div
            style={{ display: "flex", alignItems: "center", marginTop: "2px" }}
          >
            <span style={{ marginRight: "10px" }}>User Type:</span>
            <UserTypeSelectComponent
              values={documentUserType.userType}
              handler={onChangeDocument}
            />
          </div> */}
        </>
      ) : null}
      {/* <div style={{ display: "flex", alignItems: "center", marginTop: "2px" }}>
          <span style={{ marginRight: "10px" }}>User Type:</span>
          <UserTypeSelectComponent
            values={cmOverviewReducer.userTypeSelect}
            handler={onChangeData}
          />
        </div> */}
    </>
  );
};
